export default __webpack_public_path__ + "static/media/also-skills-icon.d93a9738.svg";